import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../../components/listBuilder';
import ErrorModal from '../../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT } from '../../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import viewIcon from '../../../assets/svg/eye.svg';
import refundIcon from '../../../assets/svg/refund-icon.svg';
import historyIcon from '../../../assets/svg/history-icon.svg';
import editPaymentIcon from '../../../assets/svg/edit.svg';
import cancelPaymentIcon from '../../../assets/svg/cancel-payment-icon.svg';
import addIcon from '../../../assets/svg/add-icon.svg';


import xIcon from '../../../assets/svg/x.svg';
import garbageIcon from '../../../assets/svg/garbage.svg';
import walletIcon from '../../../assets/svg/wallet.svg';
import warrning from '../../../assets/svg/warrning.svg';
import attachInvoice from '../../../assets/svg/attach.svg'
import edit from '../../../assets/svg/edit-payment-icon.svg'
import labelIcon from '../../../assets/svg/label-icon.svg'
import markPaymentIcon from '../../../assets/svg/markPaymentIcon.svg'
import adjustFreeCardIcon from '../../../assets/svg/adjust-free-card.svg'
import removeDocumentIcon from '../../../assets/svg/remove-document.svg'


import Payson from '../../../components/payson';
import Swish from '../../swish';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import PdfSave from '../../../components/pdvSave';
import InfoModal from '../../../components/infoModal';
import striptags from 'striptags';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import downloadIcon from '../../../assets/svg/download.svg';
import deleteDocument from '../../../assets/svg/delete-document.svg'

import billGrey from '../../../assets/svg/bill_grey.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import DatePicker from '../../../components/forms/fields/datePicker';
import Checkbox from '../../../components/forms/fields/checkbox';
import DeleteModal from '../../../components/deleteModal';
import PatientNotesPreview from '../../../components/patientNotesPreview';
import CustomFilters from '../components/customFilters';
import CreatePayment from '../components/createPayment';
import EditPayment from '../components/editPayment';
import RegisterPayment from '../components/registerPayment';
import { checkReasonsForPayment, getExtendedPaymentManagement, getHumanReadable, getHumanReadableLabel, getHumanReadablePaymentMethod, getHumanReadableStatus, getUserPaymentPermissions } from '../helper';
import MarkAsPaid from '../components/markAsPaid';
import MarkAsUnpaid from '../components/markAsUnpaid';
import PreviewPayment from '../components/previewPayment';
import ReferralStatusHistoryModal from '../../../components/referralStatusHistoryModal';
import RefundPayment from '../components/refundPayment';
import CancellationAndRefundSettings from '../components/cancellationAndRefundSettings';
import CancelPayment from '../components/cancelPayment';
import AttachInvoice from '../components/attachInvoice';
import AddLabel from '../components/addLabel';
import AdjustFreeCardCoverage from '../components/adjustFreeCardCoverage';
import { getTimeForPatient } from '../../referral/helper';
import RemoveAttachedInvoice from '../components/removeAttachedInvoice';
import { convertSplitDateToDivElements } from '../../calendar/helper';

function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}

class PaymentsPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
        };
    }


    get = () => {
        const customFilters = this.state.customFilters ?? {};
        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, sortField: 'tsCreated', sortType: -1, alias: localStorage.getItem('groupAlias') })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState ?
                    this.state.params
                    :
                    getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                        groupId: this.props.selectedGroup,
                        clinicId: this.props.selectedClinic,
                        filters: customFilters
                        // columnVisibility: this.state.tabIndex === 1 ? 'payments-unpaid' : this.state.tabIndex === 2 ? 'payments-paid' : null
                    })
            ).then((data) => {
                let dataToSet = { ...data }
                if (dataToSet.page || dataToSet.items || dataToSet.total) {
                    dataToSet.loading = null;
                    let checkFilter = '';
                    if (dataToSet.resultFilter) {
                        checkFilter = String(dataToSet.resultFilter)
                        delete dataToSet.resultFilter;
                    }
                    let search = this.props[0].location.search;
                    let serachParams = getSearchParams(search);
                    let searchParamsFilter = '';
                    if (serachParams.filter) {
                        searchParamsFilter = serachParams.filter;
                    }
                    if (searchParamsFilter != checkFilter) {
                        delete dataToSet.page;
                        delete dataToSet.items;
                        delete dataToSet.total;
                        delete dataToSet.loading;
                    }
                }
                this.setState({
                    ...dataToSet,
                    // loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

    }


    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();


        this.interval = setInterval(() => {
            this.get();
        }, 60 * 1000);

        // let params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0, sortField: 'tsCreated', sortType: -1 })
        // if (params.filter) {
        //     this.setState({
        //         updateFilterField: new Date().getTime()
        //     })
        // }

        this.initializeSocket();
        const userPaymentPermissions = getUserPaymentPermissions(this.props.uData, this.props.selectedGroup, this.props.selectedClinic);
        this.setState({ userPaymentPermissions });

    }
    initializeSocket = () => {
        if (this.props.uData && this.props.socket && !this.state._registerEvents) {
            this.setState({
                _registerEvents: true
            }, () => {
                this.registerEvents();
            })
        } else {
            this.socketInterval = setInterval(() => {
                if (this.props.uData && this.props.socket && !this.state._registerEvents) {
                    if (this.socketInterval) {
                        clearInterval(this.socketInterval)
                    }

                    this.setState({
                        _registerEvents: true
                    }, () => {
                        this.registerEvents();


                    })
                }
            }, 150);
        }
    }
    registerEvents = async () => {
        this.props.socket.on('newPayment', (data) => {
            this.get();
        })
    }

    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval);

        if (this.props.socket) {
            this.props.socket.removeListener('newPayment');
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }

        if (prevProps.selectedClinic != this.props.selectedClinic) {
            this.get();
        }

        if (this.props.uData?._id !== prevProps?.uData?._id) {
            const userPaymentPermissions = getUserPaymentPermissions(this.props.uData, this.props.selectedGroup, this.props.selectedClinic);
            this.setState({ userPaymentPermissions });
        }
    }


    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0, sortField: 'tsCreated', sortType: -1 },
                    [
                        {
                            name: 'sortField', value: field
                        }
                        ,
                        {
                            name: 'sortType', value: type
                        }
                    ],
                    false));

        }
    }


    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0, sortField: 'tsCreated', sortType: -1 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0, sortField: 'tsCreated', sortType: -1 }, fields, restart));
        }
    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }

        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;

        return groupData;
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }
    searchPatientWithRedirect = (SSN, enterprise) => {
        let obj = {
            socialSecurityNumber: SSN,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
        }
        enterprise && (obj.openOnWebDoc = true);

        fetch(API_ENDPOINT + '/users/find/patient', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(res => res.json()).then((result) => {
            //result = result?.error ? result?.error : result?.length ? result[0] : null;
            if (result && result._id) {
                const path = enterprise ? '/patients/search-enterprise' : '/patients/search';
                this.props.registerClinicGroupLogs({
                    type: 'patientProfile',
                    patient: SSN,
                });

                let state = {
                    TYPE: 'redirect',
                    redirectPatient: result,
                    redirectTabIndex: 1
                }
                enterprise && (state.redirectTabActive = 1);

                this.props[0].history.push(path, state);

            } else {
                this.setState({ error: 'User not found in this clinic group' })
            }
        })
    }

    getListData = (EXTENDED_PAYMENT_MANAGEMENT = false) => {
        const groupData = this.getGroupData();
        const userPaymentPermissions = this.state.userPaymentPermissions || {};

        const enterprise = groupData?.enterprise;
        const canSearchPatients = groupData?.sarchPatients;

        const patientInfoSettings = groupData?.patientInfoSettings;
        const isCustomIdEnabled = patientInfoSettings?.isCustomIdEnabled;
        const groupId = this.props.selectedGroup;
        const clinicId = this.props.selectedClinic;
        const currency = this.getCurrency();
        const defaultValue = 'N/A'.translate(this.props.lang)


        let listFields = [
            { type: 'text', name: 'caseNumber', label: 'Case ID'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'clinicInfo', label: 'Recipient'.translate(this.props.lang), allowSort: false },
            { type: 'text', name: 'patient', label: 'Patient'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'visitReason', label: 'Visit reason'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'caseStatus', label: 'Visit status'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'visitDate', label: 'Visit date'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'paymentMethod', label: 'Payment method'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'reference', label: 'Reference'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'price', label: 'Price'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'vatValueString', label: 'Varav moms'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'tsCreated', label: 'Payment created'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'tsModified', label: 'Last activity'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'status', label: 'Payment status'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'paymentCompleted', label: 'Payment completed'.translate(this.props.lang), allowSort: true },
            EXTENDED_PAYMENT_MANAGEMENT ? { type: 'text', name: 'lastReason', label: 'Status update reason'.translate(this.props.lang), allowSort: true } : null,
            EXTENDED_PAYMENT_MANAGEMENT ? { type: 'text', name: 'refundAmount', label: 'Refund Amount'.translate(this.props.lang), allowSort: true } : null,
            // { type: 'text', name: 'refundDate', label: 'Refund Date'.translate(this.props.lang), allowSort: true },
        ];
        listFields = listFields.filter(f => f != null);

        const items = this.state.items?.length ? this.state.items : [];
        const listItems = items?.map((item => {
            const caseData = item?.caseData || {};
            const doctorName = caseData?.doctorName ?? item?.createdByUser?.name ?? null;
            const { groupName, clinicName, clinicSubgroupName } = item?.clinicInfo || {};
            const { name: patientName, ssn: patientSSN, customId: patientCustomId } = item?.patientData || {};
            const amount = item?.amount?.value;
            const _currency = item?.amount?.currency || currency;
            const price = `${amount} ${_currency}`;

            const vatValue = item?.vat?.value ? Number(item.vat.value) : 0;
            const vat = typeof vatValue === 'number' ? vatValue?.toFixed(2) : '0.00';
            const vatValueString = `${vat} ${_currency}`;

            const basicInfo = item?.currentStatus ?? item?.status?.[0];
            const __status = item?.currentStatus?.status?.key ?? basicInfo?.status?.key;
            const __statusName = getHumanReadableStatus(__status, this.props.lang);
            let statusHoverData;
            if (__statusName && item?.currentStatus) {
                let time = item?.currentStatus?.time?.ts ? this.props.getStringDateTs(item.currentStatus.time.ts, `${this.props.dateFormat} HH:mm`) : null;
                let username = item?.currentStatus?.user?.username ?? item?.currentStatus?.user?.name ?? null;
                if (time && username) {
                    let actionText = __status === 'PAID' ? 'Paid' : __status === 'UNPAID' ? 'Done' : ['REFUNDED', 'PARTIALLY_REFUNDED']?.includes(__status) ? 'Refunded' : 'Changed';
                    statusHoverData = `${actionText.translate(this.props.lang)} ${'by'.translate(this.props.lang)} ${username} ${time}`;
                }
            }


            const paymentMethod = basicInfo?.paymentMethod?.key ?? defaultValue;

            const reference = basicInfo?.reference ?? defaultValue;

            let _labels = [];
            if (item?.labels?.length) {
                for (let i = item.labels.length - 1; i >= 0; i--) {
                    if (!_labels.find(el => el.label?.key === item.labels[i].label?.key)) {
                        _labels.push(item.labels[i]);
                    }
                }
                _labels = _labels.reverse();
            }
            const excludedLabels = ['patient_deleted', 'early_cancellation', 'late_cancellation'];
            const labels = _labels?.filter((label, lIdx) => !excludedLabels.includes(label?.label?.key))?.length ? _labels?.filter((label, lIdx) => !excludedLabels.includes(label?.label?.key)).map((label, lIdx) => {
                let _label = getHumanReadableLabel(label.label?.key, this.props.lang);
                const labelAddedByPatient = label?.user?.labelAddedByPatient ?? false;
                const username = labelAddedByPatient ? 'patient'.translate(this.props.lang) : label?.user?.username ?? label?.user?.name ?? null;
                const time = label?.time?.se ?? null;
                let tooltip;
                if (username && time) {
                    tooltip = `${'Done by'.translate(this.props.lang)} ${username} ${time}`;
                }
                return (
                    <div key={lIdx} className='payment-label info-tooltip'>
                        {_label}
                        {tooltip ? <div className='tooltip-text'>{tooltip}</div> : null}

                    </div>
                )
            }) : null;
            const patientLabels = _labels?.filter((label, lIdx) => label?.label?.key === 'patient_deleted')?.length ? _labels?.filter((label, lIdx) => label?.label?.key === 'patient_deleted').map((label, lIdx) => {
                let _label = getHumanReadableLabel(label.label?.key, this.props.lang);
                const labelAddedByPatient = label?.user?.labelAddedByPatient ?? false;
                const username = labelAddedByPatient ? 'patient'.translate(this.props.lang) : label?.user?.username ?? label?.user?.name ?? null;
                const time = label?.time?.se ?? null;
                let tooltip;
                if (username && time) {
                    tooltip = `${'Deleted by'.translate(this.props.lang)} ${username} ${time}`;
                }
                return (
                    <div key={lIdx} className='payment-label info-tooltip'>
                        {_label}
                        {tooltip ? <div className='tooltip-text'>{tooltip}</div> : null}

                    </div>
                )
            }) : null;
            const isLateCancellationLabelExists = _labels?.find((label) => label?.label?.key === 'late_cancellation');
            const _cancellationsLabels = _labels?.filter((label, lIdx) =>
                (!isLateCancellationLabelExists && ['early_cancellation', 'late_cancellation'].includes(label?.label?.key))
                || (isLateCancellationLabelExists && ['late_cancellation'].includes(label?.label?.key)))?.length ?
                _labels?.filter((label, lIdx) =>
                    (!isLateCancellationLabelExists && ['early_cancellation', 'late_cancellation'].includes(label?.label?.key))
                    || (isLateCancellationLabelExists && ['late_cancellation'].includes(label?.label?.key)))
                :
                null;

            const cancellationsLabels = _cancellationsLabels?.length ? _cancellationsLabels.map((label, lIdx) => {
                let _label = getHumanReadableLabel(label.label?.key, this.props.lang);
                const labelAddedByPatient = label?.user?.labelAddedByPatient ?? false;
                const username = labelAddedByPatient ? 'patient'.translate(this.props.lang) : label?.user?.username ?? label?.user?.name ?? null;
                const time = label?.time?.se ?? null;
                let tooltip;
                if (username && time) {
                    tooltip = `${'Cancelled by'.translate(this.props.lang)} ${username} ${time}`;
                }
                return (
                    <div key={lIdx} className='payment-label info-tooltip'>
                        {_label}
                        {tooltip ? <div className='tooltip-text'>{tooltip}</div> : null}

                    </div>
                )
            }) : null;
            const paymentMethodStatus = item?.attachedInvoice ? 'Invoice attached'.translate(this.props.lang) : item?.currentStatus?.paymentMethodStatus?.[this.props.lang] ?? null;
            const invoiceRequested = item?.currentStatus?.paymentMethodStatus?.en === 'Invoice requested' ? true : false;
            const paymentMethodStatusClassName = invoiceRequested ?
                'invoice-requested-payment-method-status'
                :
                item?.attachedInvoice ?
                    'attached-invoice-payment-method-status'
                    :
                    null;

            const lastReason = checkReasonsForPayment(item, this.props.lang);

            const caseStatus = caseData?.status ? getHumanReadable(caseData.status, this.props.lang) : null;
            const __visitDate = getTimeForPatient(caseData?.visitDate?.ts, caseData?.visitDate?.endTs, caseData?.visitDate?.hideTimeFromThePatient, caseData?.visitDate?.hideDurationForPatient, this.props.getStringDateTs, this.props.dateFormat, this.props.lang, true)

            const visitDate = __visitDate ? __visitDate : caseData?.visitDate?.ts ? this.props.getStringDateTs(caseData.visitDate.ts, `${this.props.dateFormat} HH:mm`) : null;
            const refundAmount = item?.amount?.refundAmount ? `${item.amount.refundAmount} ${_currency}` : null;
            const refundTs = item?.amount?.refundTime?.ts ? item?.amount?.refundTime?.ts : item?.refunds?.length && item?.refunds?.[item.refunds.length - 1]?.time?.ts;
            const refundDate = refundAmount && refundTs ? this.props.getStringDateTs(refundTs, `${this.props.dateFormat} HH:mm`) : null;
            const lastActivityTs = item?.tsModified || item?.tsCreated;
            const paymentCompletedTs = item?.paymentCompletedTime?.ts;
            return {
                ...item,
                _status: __status,
                caseNumber: item?.paymentNumber,
                clinicInfo: <div className='list-builder-field-clinic-info' style={{ minWidth: 100 }}>{clinicName}<span>{clinicSubgroupName ? <><br />{clinicSubgroupName}</> : null}{doctorName ? <><br />{doctorName}</> : null}</span></div>,
                patient: <div className='list-builder-field-status'>
                    <Button
                        color='#fff'
                        className="patient-modal-button"
                        onClick={() => {
                            if (!patientSSN) return;
                            if (enterprise || canSearchPatients) {
                                this.searchPatientWithRedirect(patientSSN, enterprise);
                            }
                        }}
                    >
                        {patientName}
                        <span className="clinic-subgroup-name">
                            {patientSSN ? <><br />{patientSSN}</> : null}
                            {isCustomIdEnabled && patientCustomId?.[groupId] ? <><br />{patientCustomId[groupId]} </> : null}
                        </span>

                    </Button>
                    {patientLabels}
                </div>,
                visitReason: caseData?.questionaryName ?? defaultValue,
                visitDate: <div className='list-builder-field-status'>
                    {visitDate ? convertSplitDateToDivElements(visitDate) : defaultValue}
                    {cancellationsLabels}
                </div>,
                caseStatus: caseStatus ?
                    <span style={{ color: caseStatus?.color }}>{caseStatus?.status} </span>
                    : defaultValue,
                price: price ?? defaultValue,
                vatValueString: vatValueString ?? defaultValue,
                tsCreated: item.tsCreated ? this.props.getStringDateTs(item.tsCreated, this.props.dateFormat + ' HH:mm') : defaultValue,
                tsModified: lastActivityTs ? this.props.getStringDateTs(lastActivityTs, this.props.dateFormat + ' HH:mm') : defaultValue,
                paymentCompleted: paymentCompletedTs ? this.props.getStringDateTs(paymentCompletedTs, this.props.dateFormat + ' HH:mm') : defaultValue,
                status: <div className='list-builder-field-status'><div className='list-builder-field-status-wrap'>{__statusName ?? defaultValue} {statusHoverData ? <span className='status-hover'>{statusHoverData}</span> : null}</div> {labels}</div>,
                paymentMethod: paymentMethod ?
                    paymentMethodStatus ?
                        <div>
                            {getHumanReadablePaymentMethod(paymentMethod, this.props.lang)}
                            <div
                                style={{ fontSize: 12, cursor: (invoiceRequested && !userPaymentPermissions?.attachInvoices) ? 'default' : 'pointer' }}
                                className={paymentMethodStatusClassName}
                                onClick={() => {
                                    if (invoiceRequested && item?._id) {
                                        if (!userPaymentPermissions?.attachInvoices) {
                                            return;
                                        }
                                        this.setState({ attachInvoiceModal: { _id: item?._id } })
                                    } else if (item?.attachedInvoice) {
                                        if (typeof window !== 'undefined') {
                                            // let url = API_ENDPOINT + item.attachedInvoice + `?mt=${this.props.uData ? this.props.uData.mediaToken : ''}&rid=${item._id}`;
                                            let url = API_ENDPOINT + item.attachedInvoice;
                                            window.open(url, '_blank')
                                        }
                                    }
                                }}
                            >
                                {paymentMethodStatus}
                            </div>
                        </div>
                        :
                        getHumanReadablePaymentMethod(paymentMethod, this.props.lang)
                    :
                    null,
                reference: reference,
                paymentMethodStatus: paymentMethodStatus,
                lastReason: lastReason ?? defaultValue, //reasons?.length ? <div>{reasons.map((r, idx) => <div key={idx} style={{ whiteSpace: 'nowrap' }}>{r.reason}</div>)}</div> : defaultValue,
                refundAmount: refundAmount ?? defaultValue,
                refundDate: refundDate ?? defaultValue,
                // <div className='list-builder-field-patient-info'>{patientName}<span>{patientSSN ? <><br />{patientSSN}</> : null}{isCustomIdEnabled && patientCustomId?.[groupId] ? <><br />{patientCustomId[groupId]}</> : null}</span></div>
            }
        }))

        return {
            listFields,
            listItems
        }
    }
    openNotes = async (item, type) => {
        if (!item) return;
        const paymentId = item?._id;
        let patientNotes = await this.checkPatientNotes(paymentId);

        let patientNotesReferralId;

        let _item = JSON.parse(JSON.stringify(item));
        if (patientNotes) {
            _item.patientNotes = patientNotes?.items ?? [];
            patientNotesReferralId = patientNotes?.caseId;
        }
        this.setState({ paymentNotes: _item, patientNotesReferralId })

    }
    checkPatientNotes = async (paymentId) => {

        if (!paymentId) {
            return [];
        }
        let data = {
            paymentId,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            lang: this.props.lang
        };
        let result = await fetch(API_ENDPOINT + `/user/patients-notes/fetch`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        try {
            let response = await result.json();
            let items = [], caseId;
            if (response?.items?.length) {
                items = response.items;
            }
            if (response?.caseId) {
                caseId = response.caseId;
            }
            return {
                items, caseId
            }

        } catch (error) {
            console.error('Error fetching patient notes:', error);
            return [];

        }


    }
    addNewNote = () => {
        const item = this.state.paymentNotes;
        const note = this.state.notesPaymentText?.trim() ?? '';
        const paymentId = item?._id;

        const data = {
            note,
            paymentId
        }

        this.setState({ loadingAddNote: true }, () => {
            fetch(API_ENDPOINT + '/api/payments/note/insert', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result && result.error) {
                    this.setState({ loadingAddNote: false, notesPaymentText: '', error: result.error });
                    this.get();
                } else if (result && result.success) {
                    this.setState({ loadingAddNote: false, notesPaymentText: '', paymentNotes: null });
                    this.get();
                }
            })
        })



    }
    exportPaymentsData = () => {
        // let exportModal = this.state.exportModal;
        // let startDate = this.state.exportModal?.startDate;
        // let endDate = this.state.exportModal?.endDate;
        // let startTs = startDate ? Math.floor(new Date(startDate).getTime() / 1000) : null;
        // let endTs = endDate ? Math.floor(new Date(endDate).getTime() / 1000) : null;
        // if ((startTs > endTs) || !startDate || !endDate) {
        //     let error = "Invalid date range: end date must be after start date.".translate(this.props.lang);
        //     exportModal.error = error;
        //     this.setState({ exportModal })
        //     return;
        // }
        // const start = moment.unix(startTs).format('MM/DD/YYYY');
        // const end = moment.unix(endTs).format('MM/DD/YYYY');

        const params = getSearchParams(this.props[0].location.search);
        const customFilters = this.state.customFilters ?? {};

        let exportData = {
            filter: params.filter,
            sortType: params.sortType,
            sortField: params.sortField,
            groupId: this.props.selectedGroup,
            clinicId: this.props.selectedClinic,
            filters: customFilters,
            lang: this.props.lang,
            export: true,
            // start: start,
            // end: end
        };

        this.setState({ loadingExport: true }, () => {
            fetch(API_ENDPOINT + '/api/payments', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(exportData)
            }).then(res => res.json()).then((result) => {
                let setObj = { loadingExport: false, exportModal: false };
                if (result?.exportData?._id && result?.exportData?.fileName) {
                    setObj.exportFileData = {
                        _id: result.exportData._id,
                        fileName: result.exportData.fileName,
                        message: `${"Your export is being prepared. You can download it from the Group statistics page on tab Payments once it's ready.".translate(this.props.lang)}`
                    }
                }
                this.setState(setObj)
                // if (result?.success && result?.file) {
                //     window.location.href = API_ENDPOINT + `${result.file}`;
                //     this.setState({ loadingExport: false, exportModal: false })
                // } else if (result?.error) {
                //     this.setState({ loadingExport: false, error: result?.error, exportModal: false })
                // }
            }).catch(() => {
                this.setState({ exportModal: false, loadingExport: false })
            })
        })




    }

    render() {
        const currency = this.getCurrency();

        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0, sortField: 'tsCreated', sortType: -1 })
        }

        const groupData = this.getGroupData();

        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);


        let enterprise = groupData?.enterprise;
        let canSearchPatients = groupData?.sarchPatients;

        const patientInfoSettings = groupData?.patientInfoSettings;


        const { listFields, listItems } = this.getListData(EXTENDED_PAYMENT_MANAGEMENT);

        const userPaymentPermissions = this.state.userPaymentPermissions || {};
        console.log(userPaymentPermissions);


        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>

                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}
                {
                    this.state.loadingExport ?
                        <div className="export-payments-loader-wrap">
                            <div className="loader-wrap" style={{ zIndex: 999999999 }}>
                                <Player
                                    autoplay={true}
                                    loop={true}
                                    renderer={'svg'}
                                    src="/lf30_editor_l5cxzdyf.json"
                                    style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                                ></Player>

                            </div>
                        </div>
                        :
                        null
                }
                {
                    this.state.exportFileData ?
                        <InfoModal
                            isOpen={this.state.exportFileData?._id}
                            toggle={() => this.setState({ exportFileData: null })}
                            header={'Info'.translate(this.props.lang)}
                            info={this.state.exportFileData?.message}
                            buttons={[
                                <Button color='primary' onClick={() => {
                                    this.props[0].history.push({ pathname: '/my-data/clinic-statistics', state: { selectedPaymentExport: this.state.exportFileData?._id } })
                                }}>{'Go to Group statistics'.translate(this.props.lang)}</Button>,
                                <Button color='primary' onClick={() => {
                                    this.setState({ exportFileData: null });
                                }}>{'Close'.translate(this.props.lang)}</Button>
                            ]}
                        />
                        :
                        null
                }


                <Container fluid>
                    <Row>
                        <div className='panel'>

                            <div className="panel-header">
                                <h5 className="component-header">{'Payments'.translate(this.props.lang)}</h5>

                                <div className='panel-header-buttons'>
                                    {
                                        EXTENDED_PAYMENT_MANAGEMENT && userPaymentPermissions?.createNewPayments ?
                                            <Button
                                                color='primary'
                                                className="btn add-button"
                                                onClick={() => {
                                                    this.setState({ createPaymentModal: true })
                                                }}>
                                                <Isvg src={addIcon} /> {'Create payment'.translate(this.props.lang)}
                                            </Button>
                                            :
                                            null
                                    }
                                    {
                                        EXTENDED_PAYMENT_MANAGEMENT && userPaymentPermissions?.exportExcelReports ?
                                            <Button
                                                color='primary'
                                                className="btn add-button"
                                                onClick={() => {
                                                    let today = new Date();
                                                    today.setHours(12, 0, 0, 0);
                                                    let monthAgo = new Date();
                                                    monthAgo.setHours(11, 0, 0, 0);
                                                    monthAgo.setMonth(monthAgo.getMonth() - 1);
                                                    let exportModal = {
                                                        startDate: moment.unix(monthAgo.getTime() / 1000).format(this.props.dateFormat),
                                                        endDate: moment.unix(today.getTime() / 1000).format(this.props.dateFormat)
                                                    }
                                                    this.setState({ exportModal })
                                                }}>
                                                {'Export'.translate(this.props.lang)}
                                            </Button>
                                            :
                                            null
                                    }

                                </div>

                            </div>


                            <Col lg="12" className='col-no-padding'>
                                {/* {this.state.items.length > 0 ? <p></p> :
                                    <p> {'Do not have unpaid referrals'.translate(this.props.lang)}</p>} */}
                                {

                                    <ListBuilder
                                        lang={this.props.lang}
                                        loading={this.state.loading}
                                        total={this.state.total}
                                        showNumeration={false}
                                        updateFilterField={this.state.updateFilterField}
                                        columnVisibility={'payments'} //columnVisibility
                                        uData={this.props.uData} //columnVisibility
                                        updateListBuilderFields={this.props.updateListBuilderFields} //columnVisibility
                                        get={this.get}//columnVisibility
                                        fields={listFields}
                                        rawItems={this.state.items}
                                        items={listItems}
                                        actionBars={true}
                                        actionColClassName='action-col-with-bars-payments'
                                        tableClassNameOneItem='payments-list-builder-table'
                                        bothSideSidebars={true}
                                        customFilters={
                                            <CustomFilters
                                                {...this.props}
                                                onChange={(data) => {
                                                    if (data?.visitStatus?.includes('canceled-by-clinic') && !data?.visitStatus?.includes('not-booked')) {
                                                        data.visitStatus.push('not-booked');
                                                    }
                                                    if (data?.visitStatus?.includes('not-booked') && !data?.visitStatus?.includes('canceled-by-clinic')) {
                                                        data.visitStatus = data.visitStatus.filter(status => status !== 'not-booked');
                                                    }
                                                    const _data = JSON.parse(JSON.stringify(data));
                                                    const customFilters = JSON.parse(JSON.stringify(this.state.customFilters ?? {}));
                                                    if (JSON.stringify(_data) !== JSON.stringify(customFilters)) {
                                                        this.setState({ customFilters: _data }, () => {
                                                            let currentPage = params?.page ? String(params.page) : '0';
                                                            if (currentPage === '0') {
                                                                this.get();
                                                            } else {
                                                                this.updateParams('page', 0);
                                                            }

                                                        });
                                                    }
                                                }}
                                                customFilters={this.state.customFilters}
                                                userPaymentPermissions={userPaymentPermissions}
                                                EXTENDED_PAYMENT_MANAGEMENT={EXTENDED_PAYMENT_MANAGEMENT}
                                            />
                                        }
                                        actions={
                                            [
                                                {
                                                    renderComponent: item =>
                                                        <div className="tabel-action-tooltip" >
                                                            <Isvg src={infoIcon} className={item?.notes?.length || item?.hasPatientNotes ? 'note-icon-wrap note-icon-green' : "note-icon-wrap"} />
                                                            <div className="chat-icons-tooltip">
                                                                <span>{item?.notes?.length || item?.hasPatientNotes ? 'Notes available'.translate(this.props.lang) : 'Note'.translate(this.props.lang)}</span>
                                                            </div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        this.openNotes(item)
                                                    },
                                                    condition: (item) => {
                                                        //  const allowedStatuses = ["UNPAID", "PAID", "REFUNDED", "PARTIALLY_REFUNDED", "CANCELLED"];
                                                        let condition = true;
                                                        return condition;
                                                    },
                                                    showOutsideOfActionBars: true
                                                },
                                                {
                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={viewIcon} style={{ width: 24, minWidth: 24 }} />
                                                            <div style={{ width: 180 }} className="chat-icons-tooltip">{'Receipt'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        // TODO: show receipt
                                                        this.setState({ previewPayment: item })
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["PAID", "REFUNDED", "PARTIALLY_REFUNDED"];
                                                        const labels = item?.labels?.map(label => label.label?.key) || [];
                                                        let condition = allowedStatuses?.indexOf(status) > -1 ? true : false;
                                                        return condition;
                                                    }
                                                },
                                                // {
                                                //     component:
                                                //         <div className="tabel-action-tooltip">
                                                //             <Isvg src={labelIcon} className="add-label-icon" style={{ width: 24, minWidth: 24 }} />
                                                //             <div style={{ width: 180 }} className="chat-icons-tooltip">{'Add label'.translate(this.props.lang)}</div>
                                                //         </div>,
                                                //     onClick: (item) => {
                                                //         const paymentId = item?._id;
                                                //         if (!paymentId) return;
                                                //         this.setState({ addLabelModal: paymentId })
                                                //     },
                                                //     condition: (item) => {
                                                //         // const status = item?._status;
                                                //         // const allowedStatuses = ["PAID", "REFUNDED", "PARTIALLY_REFUNDED"];
                                                //         // const labels = item?.labels?.map(label => label.label?.key) || [];
                                                //         let condition = true;
                                                //         return condition;
                                                //     }
                                                // },
                                                {
                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={attachInvoice} style={{ width: 24, minWidth: 24 }} />
                                                            <div style={{ width: 180 }} className="chat-icons-tooltip">{'Attach invoice'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        this.setState({ attachInvoiceModal: item })
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["UNPAID"];
                                                        const requestedInvoice = item?.currentStatus?.paymentMethod?.key === 'invoice' ? true : false;
                                                        const attachedInvoiceExists = item?.attachedInvoice ? true : false;

                                                        let condition = allowedStatuses?.indexOf(status) > -1 && requestedInvoice && !attachedInvoiceExists ? true : false;
                                                        if (condition && !userPaymentPermissions?.attachInvoices) {
                                                            condition = false;
                                                        }
                                                        return condition;
                                                    }
                                                },
                                                {
                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={downloadIcon} style={{ width: 24, minWidth: 24 }} />
                                                            <div style={{ width: 180 }} className="chat-icons-tooltip">{'Download invoice'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        if (typeof window !== 'undefined') {
                                                            // let url = API_ENDPOINT + item.attachedInvoice + `?mt=${this.props.uData ? this.props.uData.mediaToken : ''}&rid=${item._id}`;
                                                            let url = API_ENDPOINT + item.attachedInvoice;
                                                            window.open(url, '_blank')
                                                        }
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["UNPAID"];
                                                        const requestedInvoice = item?.currentStatus?.paymentMethod?.key === 'invoice' ? true : false;
                                                        const attachedInvoiceExists = item?.attachedInvoice ? true : false;

                                                        let condition = /* allowedStatuses?.indexOf(status) > -1 && */requestedInvoice && attachedInvoiceExists ? true : false;

                                                        return condition;
                                                    }
                                                },
                                                {
                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={removeDocumentIcon} style={{ width: 24, minWidth: 24 }} />
                                                            <div style={{ width: 180 }} className="chat-icons-tooltip">{'Remove attached invoice'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        this.setState({ removeAttachedInvoiceModal: item })
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["UNPAID"];
                                                        const requestedInvoice = item?.currentStatus?.paymentMethod?.key === 'invoice' ? true : false;
                                                        const attachedInvoiceExists = item?.attachedInvoice ? true : false;

                                                        let condition = allowedStatuses?.indexOf(status) > -1 && requestedInvoice && attachedInvoiceExists ? true : false;
                                                        if (condition && !userPaymentPermissions?.attachInvoices) {
                                                            condition = false;
                                                        }
                                                        return condition;
                                                    }
                                                },
                                                {
                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={markPaymentIcon} style={{ width: 24, minWidth: 24, maxHeight: 24 }} />
                                                            <div style={{ width: 180 }} className="chat-icons-tooltip">{'Mark as paid'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        // TODO: mark as paid
                                                        this.setState({ markAsPaidModal: item })
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["UNPAID"];
                                                        let condition = allowedStatuses?.indexOf(status) > -1 ? true : false;
                                                        const labels = item?.labels?.map(label => label.label?.key) || [];
                                                        if (condition && (labels?.includes('payment_cancelled') || labels?.includes('patient_deleted') || labels?.includes('case_deleted'))) {
                                                            condition = false;
                                                        }
                                                        if (condition && (item?.currentStatus?.paymentMethod?.key === 'paymentOnSite' || item?.currentStatus?.paymentMethod?.key === 'freeCard')) {
                                                            condition = false;
                                                        }
                                                        if (condition && !userPaymentPermissions?.markAsPaidAndRegisterPayment) {
                                                            condition = false;
                                                        }
                                                        if (condition && !EXTENDED_PAYMENT_MANAGEMENT) {
                                                            condition = false;
                                                        }
                                                        return condition;
                                                    }
                                                },
                                                {
                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={edit} style={{ width: 22, minWidth: 22, maxHeight: 22 }} />
                                                            <div style={{ width: 180 }} className="chat-icons-tooltip">{'Mark as unpaid'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        // TODO: mark as unpaid
                                                        this.setState({ markAsUnpaidModal: item })
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["PAID"];
                                                        let condition = allowedStatuses?.indexOf(status) > -1 ? true : false;
                                                        const labels = item?.labels?.map(label => label.label?.key) || [];
                                                        const paymentMethod = item?.currentStatus?.paymentMethod?.key ?? null;
                                                        const allowedPaymentMethods = ['registeredManually', 'freeCard'];
                                                        if (condition && !allowedPaymentMethods.includes(paymentMethod)) {
                                                            condition = false;
                                                        }
                                                        if (condition && !userPaymentPermissions?.markAsPaidAndRegisterPayment) {
                                                            condition = false;
                                                        }
                                                        if (condition && !EXTENDED_PAYMENT_MANAGEMENT) {
                                                            condition = false;
                                                        }
                                                        // if (condition && labels?.includes('patient_deleted')) {
                                                        //     condition = false;
                                                        // }
                                                        return condition;
                                                    }
                                                },
                                                {
                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={refundIcon} className='refund-icon-svg' style={{ width: 24, minWidth: 24 }} />
                                                            <div style={{ width: 180 }} className="chat-icons-tooltip">{'Refund payment'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        // TODO: refund payment
                                                        const paymentId = item?._id;
                                                        if (!paymentId) return;
                                                        this.setState({ refundPaymentModal: paymentId })
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["PAID", "PARTIALLY_REFUNDED"];
                                                        let condition = allowedStatuses?.indexOf(status) > -1 ? true : false;
                                                        const price = item?.amount?.value ? String(item?.amount?.value) : '0';
                                                        if (condition && price === '0') {
                                                            condition = false;
                                                        }

                                                        if (!EXTENDED_PAYMENT_MANAGEMENT || !userPaymentPermissions?.refundPayments) condition = false;
                                                        return condition;
                                                    }
                                                },
                                                {

                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={adjustFreeCardIcon} className="adjust-free-card-coverage-icon" />
                                                            <div className="chat-icons-tooltip">{'Adjust free card coverage'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        const paymentId = item?._id;
                                                        if (!paymentId) return;
                                                        this.setState({ adjustFreeCardCoverageModal: paymentId })
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["UNPAID"];
                                                        const requestedFreeCardPayment = item?.currentStatus?.paymentMethod?.key === 'freeCard' ? true : false;
                                                        let condition = allowedStatuses?.indexOf(status) > -1 && requestedFreeCardPayment ? true : false;

                                                        const labels = item?.labels?.map(label => label.label?.key) || [];
                                                        if (condition && (labels?.includes('payment_cancelled') || labels?.includes('patient_deleted') || labels?.includes('case_deleted'))) {
                                                            condition = false;
                                                        }
                                                        if (condition && !userPaymentPermissions?.editPayments) {
                                                            condition = false;
                                                        }
                                                        return condition;
                                                    }
                                                },
                                                {

                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={walletIcon} className="wallet-icon" />
                                                            <div className="chat-icons-tooltip">{'Register payment'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        this.setState({ registerPaymentModal: item })
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["UNPAID"];
                                                        const requestedInvoice = item?.currentStatus?.paymentMethod?.key === 'invoice' ? true : false;
                                                        const attachedInvoiceExists = item?.attachedInvoice && requestedInvoice ? true : false;
                                                        const requestedPaymentOnSite = item?.currentStatus?.paymentMethod?.key === 'paymentOnSite';
                                                        let condition = allowedStatuses?.indexOf(status) > -1 && (attachedInvoiceExists || requestedPaymentOnSite) ? true : false;

                                                        const labels = item?.labels?.map(label => label.label?.key) || [];
                                                        if (condition && (labels?.includes('payment_cancelled') || labels?.includes('patient_deleted') || labels?.includes('case_deleted'))) {
                                                            condition = false;
                                                        }
                                                        if (condition && !userPaymentPermissions?.markAsPaidAndRegisterPayment) {
                                                            condition = false;
                                                        }
                                                        return condition;
                                                    }
                                                },
                                                {
                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={historyIcon} className="view-history-icon" />
                                                            <div className="chat-icons-tooltip">{'View history'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        // TODO: View history
                                                        this.setState({ statusHistoryModal: item })
                                                    },
                                                    condition: (item) => {

                                                        let condition = true;
                                                        return condition;
                                                    }
                                                },
                                                {
                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={editPaymentIcon} className="view-history-icon" />
                                                            <div className="chat-icons-tooltip">{'Edit payment'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        const paymentId = item?._id;
                                                        if (!paymentId) return;
                                                        this.setState({ editPaymentModal: paymentId })
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["UNPAID"];
                                                        let condition = allowedStatuses?.indexOf(status) > -1 ? true : false;
                                                        const labels = item?.labels?.map(label => label.label?.key) || [];
                                                        if (condition && (labels?.includes('payment_cancelled') || labels?.includes('patient_deleted') || labels?.includes('case_deleted'))) {
                                                            condition = false;
                                                        }
                                                        if (!EXTENDED_PAYMENT_MANAGEMENT || !userPaymentPermissions?.editPayments) condition = false;
                                                        return condition;
                                                    }
                                                },
                                                {
                                                    component:
                                                        <div className="tabel-action-tooltip">
                                                            <Isvg src={cancelPaymentIcon} className="cancel-payment-icon" />
                                                            <div className="chat-icons-tooltip">{'Cancel payment'.translate(this.props.lang)}</div>
                                                        </div>,
                                                    onClick: (item) => {
                                                        // TODO: Cancel payment
                                                        this.setState({ cancelPaymentModal: item })
                                                    },
                                                    condition: (item) => {
                                                        const status = item?._status;
                                                        const allowedStatuses = ["UNPAID"];
                                                        let condition = allowedStatuses?.indexOf(status) > -1 ? true : false;

                                                        const labels = item?.labels?.map(label => label.label?.key) || [];
                                                        if (condition && labels?.includes('payment_cancelled')) {
                                                            condition = false;
                                                        }
                                                        if (condition && !userPaymentPermissions?.cancelPayments) {
                                                            condition = false;
                                                        }

                                                        return condition;
                                                    }
                                                },
                                            ]
                                        }
                                        params={params}
                                        sortField={params.sortField}
                                        sortType={params.sortType}
                                        updateSort={this.updateSort}
                                        updateParams={this.updateParams}
                                        updateMultipleParams={this.updateMultipleParams}
                                    ></ListBuilder>

                                }


                            </Col>
                        </div>
                    </Row>


                </Container>
                {
                    this.state.exportModal ?
                        <Modal centered isOpen={this.state.exportModal}>
                            <ModalHeader style={{ margin: 'auto' }}>{'Export'.translate(this.props.lang)}</ModalHeader>
                            <ModalBody>

                                {/* <FormGroup>
                                    <DatePicker
                                        label={'Date from'.translate(this.props.lang)}
                                        value={this.state.exportModal.startDate}
                                        dateFormat={this.props.dateFormat}
                                        maxDate={new Date(this.state.exportModal.endDate)}
                                        onChange={(e) => {
                                            let exportModal = this.state.exportModal;
                                            exportModal.startDate = e;
                                            exportModal.error = null;
                                            this.setState({ exportModal });
                                        }} />
                                </FormGroup>
                                <FormGroup>
                                    <DatePicker
                                        label={'Date to'.translate(this.props.lang)}
                                        value={this.state.exportModal.endDate}
                                        minDate={new Date(this.state.exportModal.startDate)}
                                        dateFormat={this.props.dateFormat}
                                        onChange={(e) => {
                                            let exportModal = this.state.exportModal;
                                            if (exportModal?.startDate && new Date(exportModal?.startDate).getTime() > new Date(e)) {
                                                exportModal.endDate = exportModal.startDate
                                            } else {
                                                exportModal.endDate = e;
                                            }
                                            exportModal.error = null;

                                            this.setState({ exportModal });
                                        }} />
                                </FormGroup> */}

                                <FormGroup className='all-cases-important-export-text' >
                                    <Label>{'Important!'.translate(this.props.lang)}</Label>
                                    <p>
                                        {'The export file will be downloaded and stored locally on your device. Please make sure to handle the data responsibly and delete the file once it is no longer required'.translate(this.props.lang)}
                                    </p>
                                </FormGroup>
                                {
                                    this.state.exportModal?.error ?
                                        <FormGroup>
                                            <p style={{ color: 'red' }}>{this.state.exportModal.error}</p>
                                        </FormGroup>
                                        :
                                        null
                                }
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button disabled={this.state.loadingExport ? true : false} color="primary" style={{ margin: 10 }} onClick={() => {
                                    this.exportPaymentsData()
                                }}>{'Export'.translate(this.props.lang)}</Button>

                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ exportModal: null })

                                }>{'Close'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        // <InfoModal
                        //     isOpen={this.state.exportModal}
                        //     toggle={() => this.setState({ exportModal: null })}
                        //     header={'Info'.translate(this.props.lang)}
                        //     info={this.state.exportModal?.translate(this.props.lang)}
                        //     buttons={[
                        //         <Button color='primary' onClick={() => {
                        //             this.exportPaymentsData();
                        //         }}>{'Yes'.translate(this.props.lang)}</Button>,
                        //         <Button color='primary' onClick={() => {
                        //             this.setState({ exportModal: null });
                        //         }}>{'No'.translate(this.props.lang)}</Button>
                        //     ]}
                        // />
                        :
                        null

                }
                {
                    this.state.cancelPaymentModal ?
                        <CancelPayment
                            {...this.props}
                            isOpen={this.state.cancelPaymentModal?._id}
                            onClose={(callback) => {
                                this.setState({ cancelPaymentModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        /> : null
                }

                {
                    this.state.statusHistoryModal ? <ReferralStatusHistoryModal
                        isOpen={this.state.statusHistoryModal}
                        currency={this.props.currency}
                        onClose={() => this.setState({ statusHistoryModal: null })}
                        history={this.state.statusHistoryModal?.caseData?._id ?? this.state.statusHistoryModal?._id}
                        lang={this.props.lang}
                        country={this.props.country}
                        getStringDateTs={this.props.getStringDateTs}
                    /> : null
                }
                {
                    this.state.previewPayment ?
                        <PreviewPayment
                            {...this.props}
                            isOpen={this.state.previewPayment?._id}
                            onClose={(callback) => {
                                this.setState({ previewPayment: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }

                {
                    this.state.markAsUnpaidModal ?
                        <MarkAsUnpaid
                            {...this.props}
                            isOpen={this.state.markAsUnpaidModal?._id}
                            onClose={(callback) => {
                                this.setState({ markAsUnpaidModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null

                }
                {
                    this.state.markAsPaidModal ?
                        <MarkAsPaid
                            {...this.props}
                            isOpen={this.state.markAsPaidModal?._id}
                            onClose={(callback) => {
                                this.setState({ markAsPaidModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null

                }
                {
                    this.state.registerPaymentModal ?
                        <RegisterPayment
                            {...this.props}
                            isOpen={this.state.registerPaymentModal?._id}
                            onClose={(callback) => {
                                this.setState({ registerPaymentModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.refundPaymentModal ?
                        <RefundPayment
                            {...this.props}
                            isOpen={this.state.refundPaymentModal}
                            onClose={(callback) => {
                                this.setState({ refundPaymentModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.removeAttachedInvoiceModal ?
                        <RemoveAttachedInvoice
                            {...this.props}
                            isOpen={this.state.removeAttachedInvoiceModal?._id}
                            onClose={(callback) => {
                                this.setState({ removeAttachedInvoiceModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.attachInvoiceModal ?
                        <AttachInvoice
                            {...this.props}
                            isOpen={this.state.attachInvoiceModal?._id}
                            onClose={(callback) => {
                                this.setState({ attachInvoiceModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.addLabelModal ?
                        <AddLabel
                            {...this.props}
                            isOpen={this.state.addLabelModal}
                            onClose={(callback) => {
                                this.setState({ addLabelModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.adjustFreeCardCoverageModal ?
                        <AdjustFreeCardCoverage
                            {...this.props}
                            isOpen={this.state.adjustFreeCardCoverageModal}
                            onClose={(callback) => {
                                this.setState({ adjustFreeCardCoverageModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }

                {
                    this.state.editPaymentModal ?
                        <EditPayment
                            {...this.props}
                            isOpen={this.state.editPaymentModal}
                            onClose={(callback) => {
                                this.setState({ editPaymentModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }

                {
                    this.state.createPaymentModal ?
                        <CreatePayment
                            {...this.props}
                            isOpen={this.state.createPaymentModal}
                            onClose={(callback) => {
                                this.setState({ createPaymentModal: false }, () => {
                                    this.get();
                                    setTimeout(() => {
                                        this.get();
                                    }, 5000);
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.paymentNotes ?
                        <Modal size='lg' centered isOpen={this.state.paymentNotes}>
                            <ModalHeader style={{ paddingBottom: 0 }}> {'Notes'.translate(this.props.lang)} </ModalHeader>
                            <ModalBody className="delete-modal">
                                {
                                    this.state.paymentNotes?.patientNotes ?
                                        <div className='patient-notes-preview-wrap'>
                                            <PatientNotesPreview
                                                {...this.props}
                                                isOpen={this.state.showPatientNotes}
                                                items={this.state.paymentNotes?.patientNotes}
                                                paymentNumber={this.state.paymentNotes?.paymentNumber}
                                                paymentId={this.state.paymentNotes?.paymentId}
                                                caseId={this.state.patientNotesReferralId}
                                                toggle={() => { }
                                                }
                                                showInModal={false}
                                            />
                                        </div>
                                        :
                                        this.state.paymentNotes?.notes && this.state.paymentNotes?.notes.length ?
                                            <ul style={{ listStyle: 'none', padding: 5, textAlign: 'left' }}>
                                                {
                                                    this.state.paymentNotes.notes.map((note, i) => {
                                                        let name;
                                                        note.username ? (name = note.username) : (name = note.name);
                                                        let date;
                                                        if (note.timestamp) {
                                                            try {
                                                                let dateObj = new Date(note.timestamp);
                                                                // console.log(dateObj);
                                                                if (dateObj) {
                                                                    date = `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()}`
                                                                }
                                                            } catch (err) {
                                                                console.log('date err: ', err);
                                                            }

                                                        }
                                                        let message;
                                                        switch (note.action) {
                                                            case 'unpaid-to-paid': message = 'marked this case as paid on'.translate(this.props.lang); break;
                                                            case 'paid-to-unpaid': message = 'marked this case as unpaid on'.translate(this.props.lang); break;
                                                            case 'new-note': message = 'added a new note on'.translate(this.props.lang)
                                                        }

                                                        let addedNote;
                                                        if (note.note && note.note !== '' && note.note.trim() !== '') {
                                                            if (note.action === 'new-note') {
                                                                addedNote = ': ' + `"${note.note}"`
                                                            } else {
                                                                addedNote = ', ' + 'with note'.translate(this.props.lang) + ': ' + `"${note.note}"`;
                                                            }
                                                        }
                                                        let string;
                                                        if (name && message && date) {
                                                            string = name + ' ' + message + ' ' + date;
                                                            if (addedNote) string += addedNote;
                                                        }
                                                        return <li key={i}> {i + 1 + '. '
                                                        } {' '} {string ? string + '.' : 'Note'.translate(this.props.lang)} </li>
                                                    })}
                                            </ul>
                                            :
                                            <div style={{ marginBottom: 20, display: 'flex', fontStyle: 'italic' }}> {'There are still no notes added.'.translate(this.props.lang)} </div>
                                }
                                <Input type="textarea" placeholder={'Enter new note'.translate(this.props.lang)} style={{ height: 100 }} value={this.state.notesPaymentText} onChange={(e) => { this.setState({ notesPaymentText: e.target.value }) }} />
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button
                                    disabled={!this.state.notesPaymentText || this.state.notesPaymentText === '' || this.state.notesPaymentText.trim() === '' || this.state.loadingAddNote}
                                    color="primary"
                                    style={{ margin: 10 }}
                                    onClick={() => {
                                        this.addNewNote();
                                    }}
                                > {'Save'.translate(this.props.lang)} </Button>

                                <Button
                                    color="primary"
                                    style={{ margin: 10 }}
                                    onClick={() => this.setState({ paymentNotes: null, notesPaymentText: '' })}
                                >
                                    {'Close'.translate(this.props.lang)}
                                </Button>

                            </ModalFooter>
                        </Modal> : null}
            </div >
        );
    }
}

const selector = formValueSelector('modalForm');

export default connect(state => {
    return { group: selector(state, 'group') }

}, {
    changeSubgroup: value => change("modalForm", "subgroup", value),

})(Page(PaymentsPage));
